import { render } from "./photo.vue?vue&type=template&id=732bdfd4&scoped=true"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"

import "./photo.vue?vue&type=style&index=0&id=732bdfd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732bdfd4"]])

export default __exports__